import axios from 'axios';
import { newAbortSignal } from '../../utils';
import { SessionStore } from '../../types/store/SessionStore';
import { User } from '../../types/interfaces/user';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/account`;

export const getEligibleManagers = async (
  accountId: number,
  projectId?: number,
  activityId?: number,
  procedureId?: number
): Promise<User[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem('session') || '{}'
  );

  const queryParams = new URLSearchParams();
  if (projectId) queryParams.append('projectId', projectId.toString());
  if (activityId) queryParams.append('activityId', activityId.toString());
  if (procedureId) queryParams.append('procedureId', procedureId.toString());

  const finalURL = `${BASE_URL}/${accountId}/eligible-managers?${queryParams}`;

  return axios
    .get<User[]>(finalURL, {
      headers: {
        'content-type': 'application/json',
        'x-access-token': session?.accessToken,
      },
      timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        typeof AbortSignal.timeout !== 'undefined'
          ? AbortSignal.timeout(
              parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)
            )
          : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
    })
    .then((response) => response.data);
};
